import React from 'react';
import { StyleSheet } from 'react-native';

import { BodyText, Button, Container, DisplayText, LoadingAnimation, TitleText } from '@sg/garnish';

import { useFlexEnrollment } from '@order/features-payments';
import { useFeatureFlag } from '@order/LaunchDarkly';
import { useTrackEffect } from '@order/Telemetry';

import { SignedOutView } from '../../components';
import { useIsLoggedIn } from '../../context/AuthMachine';
import { NotFoundScreen } from '../NotFoundScreen';

export const HsaFsaScreen = () => {
  const isLoggedIn = useIsLoggedIn();
  const isFlexEnabled = useFeatureFlag('CELS-5522-flex-enabled');

  if (!isFlexEnabled) {
    return <NotFoundScreen />;
  }

  if (!isLoggedIn) {
    return <SignedOutView redirectTo="/hsa-fsa" />;
  }

  return <HsaFsaReady />;
};

const HsaFsaReady = () => {
  const {
    isPreparingEnrollment,
    hasFlexPaymentMethod,
    isLoadingFlexSession,
    checkFlexEligibility,
  } = useFlexEnrollment();

  useTrackEffect('hsafsa.landing_page.viewed');

  if (isPreparingEnrollment) {
    return <LoadingAnimation />;
  }

  if (hasFlexPaymentMethod) {
    return (
      <Container style={styles.container}>
        <DisplayText>Coming soon</DisplayText>
        <TitleText>HSA/FSA</TitleText>

        <BodyText>You are already enrolled in HSA/FSA.</BodyText>
      </Container>
    );
  }

  return (
    <Container style={styles.container}>
      <DisplayText>Coming soon</DisplayText>
      <TitleText>HSA/FSA</TitleText>

      <Button isLoading={isLoadingFlexSession} onPress={checkFlexEligibility}>
        Check eligibility
      </Button>
    </Container>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 120,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
